import '../../style/store/store product/SP_NecessaryFile.css';
import { FiPlus,FiMinus } from "react-icons/fi";
import { VscCircleFilled } from "react-icons/vsc";
import { useState } from 'react';

import icon1 from '../../../assets/store/note-2.png';
// import icon1 from '../../../assets/store/vuesax-linear-note-2@2x.png';

import icon2 from '../../../assets/store/Group 149.png';

const SP_NecessaryFile=({files})=>{

  const [toggleIcon,set_toggleIcon] = useState(true);
  const [MtoggleIcon,set_MtoggleIcon] = useState(true);
  const text_file_open=()=>{
    set_toggleIcon(false);
    document.querySelector(".sp-necessary-file-text-file").classList.add("sp-necessary-file-text-file-open");
  }

  const text_file_close=()=>{
    set_toggleIcon(true);
    document.querySelector(".sp-necessary-file-text-file").classList.remove("sp-necessary-file-text-file-open");
  }

  const media_file_open=()=>{
    set_MtoggleIcon(false);
    document.querySelector(".sp-necessary-file-media-file").classList.add("sp-necessary-file-media-file-open");
  }

  const media_file_close=()=>{
    set_MtoggleIcon(true);
    document.querySelector(".sp-necessary-file-media-file").classList.remove("sp-necessary-file-media-file-open");
  }

  return(
    <div className="sp-necessary-file">
      <div className="sp-necessary-file-title">
        فایل‌های مورد نیاز برای شرکت در آزمون
      </div>
      <div className="sp-necessary-file-text-file">
        <div className="sp-n-f-t-f-title-box">
          <div className="sp-n-f-t-f-title-box-p1">
            <img src={icon1} alt="text-file-icon" className="sp-n-f-t-f-title-box-p1-icon"/>
            <div className="sp-n-f-t-f-title-box-p1-title">مخصوص فایل های متنی از جمله پی دی اف و ورد</div>
          </div>
          <div className="sp-n-f-t-f-title-box-p2">
            {toggleIcon && <FiPlus className="sp-n-f-t-f-title-box-p2-plus-icon" onClick={text_file_open}/>}
            {!toggleIcon  && <FiMinus className="sp-n-f-t-f-title-box-p2-minus-icon" onClick={text_file_close}/>}
          </div>
        </div>
        <div className="sp-n-f-t-f-items">
          {files[0].map(item=>(
            <div key={item.id} className="sp-n-f-t-f-items-item">
              <VscCircleFilled className="sp-n-f-t-f-items-item-icon"/>
              <a className="sp-n-f-t-f-items-item-text" href={item.path}>{item.text}</a>
            </div>
          ))}
        </div>
      </div>

      <div className="sp-necessary-file-media-file">
        <div className="sp-n-f-m-f-title-box">
          <div className="sp-n-f-m-f-title-box-p1">
            <img src={icon2} alt="media-file-icon" className="sp-n-f-m-f-title-box-p1-icon"/>
            <div className="sp-n-f-m-f-title-box-p1-title">مخصوص فایل های متنی از جمله پی دی اف و ورد</div>
          </div>
          <div className="sp-n-f-m-f-title-box-p2">
            {MtoggleIcon && <FiPlus className="sp-n-f-m-f-title-box-p2-plus-icon" onClick={media_file_open}/>}
            {!MtoggleIcon  && <FiMinus className="sp-n-f-m-f-title-box-p2-minus-icon" onClick={media_file_close}/>}
          </div>
        </div>
        <div className="sp-n-f-m-f-items">
          {files[1].map(item=>(
            <div key={item.id} className="sp-n-f-m-f-items-item">
              <VscCircleFilled className="sp-n-f-m-f-items-item-icon"/>
              <a className="sp-n-f-m-f-items-item-text" href={item.path}>{item.text}</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}


export default SP_NecessaryFile;

